import { LoaderCircle } from 'lucide-react';

export default function LoadingPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="flex flex-col">
        <LoaderCircle
          className="text-primary-500 h-12 w-12 animate-spin"
          strokeWidth={1.5}
        />
      </div>
    </div>
  );
}
